import { getData } from "./apiService";

class WebSocketService {
  constructor(onMessageCallback) {
    this.socket = null;
    this.onMessageCallback = onMessageCallback;
    this.shouldReconnect = true; // Flag per controllare la riconnessione
    this.initialize();
  }

  async initialize() {
    const pathWS = await this.checkShouldConnect();
    if (pathWS !== "") {
      //console.log("Connetto a:", pathWS);
      this.connect(pathWS);
    } else {
      console.error("Nessun percorso WebSocket valido.");
      if (this.socket && (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING)) {
        this.disconnect();
        //console.log("Disconnetto");
      } else {
        //console.log("Non mi connetto");
      }
    }
  }

  async checkShouldConnect() {
    try {
      const apiUrl = "VariabiliStrutture/GetPathWS";
      const response = await getData(apiUrl);
      if (response.isSuccess) return response.message;
      else return "";
    } catch (error) {
      console.error("Failed to check connection condition", error);
      return ""; // Non stabilisce la connessione in caso di errore
    }
  }

  connect(pathWS) {
    if (pathWS && pathWS !== "") {
      try {
        this.socket = new WebSocket(pathWS);
        this.socket.onopen = () => {
          //console.log("WebSocket connection opened");
        };

        this.socket.onmessage = (event) => {
          try {
            const message = JSON.parse(event.data);
            //console.log("Message from server:", message);
            if (this.onMessageCallback) {
              this.onMessageCallback(message);
            }
          } catch (parseError) {
            console.error("Error parsing message:", parseError);
          }
        };

        this.socket.onclose = (event) => {
          console.log("WebSocket connection closed", event);
          if (this.shouldReconnect) {
            console.log("Attempting to reconnect...");
            setTimeout(() => this.connect(pathWS), 1000); // Riconnette automaticamente se shouldReconnect è true
          }
        };

        this.socket.onerror = (error) => {
          console.error("WebSocket error observed:", error);
          const message = {
            Status: "-1",
            Message: error.message || "Errore di connessione webSocket",
            PdfFirmato: "",
            id: 0,
          };
          const messageString = JSON.stringify(message);
          if (this.onMessageCallback) {
            this.onMessageCallback(messageString);
          }
          this.disconnect();
        };
      } catch (error) {
        //console.error("Error during WebSocket connection:", error);
      }
    }
  }

  sendMessage(message) {
    if (this.socket.readyState === WebSocket.OPEN) {
      const jsonMessage = JSON.stringify(message);
      this.socket.send(jsonMessage);
    } else {
      alert("Errore connessione web socket!");
      //console.error("Error: WebSocket is not open, current state:", this.socket.readyState);
    }
  }

  disconnect() {
    this.shouldReconnect = false; // Impedisce la riconnessione automatica
    if (this.socket) {
      this.socket.onclose = null; // Rimuovi l'eventuale callback di riconnessione automatica prima di chiudere
      this.socket.close(); // Chiude il WebSocket
      //console.log("WebSocket connection manually closed");
    }
  }
}

const webSocketService = new WebSocketService();
export default webSocketService;
